<script>
import FormElement from '@wielink-application/shared/vue/components/form/input-only/color.vue'

export default FormElement;
</script>